// REVIEW SLIDER -- START
document.addEventListener("DOMContentLoaded", function() {
  // em box design class
  const textBlocks = document.querySelectorAll('.lfeature_text_block');
  //console.log('🟢 Found', textBlocks.length, '.lfeature_text_block elements');
  textBlocks.forEach(block => {
    const emTags = block.querySelectorAll('em');
    //console.log('📍 Found', emTags.length, '<em> inside one block');
    emTags.forEach(em => {
      const text = em.textContent.trim();
      const wordCount = text.split(/\s+/).filter(w => w.length > 0).length;
      //console.log('🔍 Text:', `"${text}"`, '| Word count:', wordCount);
      if (wordCount > 6) {
        em.classList.add('long-em');
        //console.log('✨ Added class .long-em');
      }

      // If text contains "20 years", make it bold
      if (text.toLowerCase().includes('20 years')) {
        // Replace "20 years" with bold version
        em.innerHTML = text.replace(/(20 years)/gi, '<strong>$1</strong>');
      }
      
      // If text contains "24 hours", make it bold
      if (text.toLowerCase().includes('24 hours')) {
        // Replace "24 hours" with bold version
        em.innerHTML = text.replace(/(24 hours)/gi, '<strong>$1</strong>');
      }
      
      // If text contains "8 years", make it bold
      if (text.toLowerCase().includes('8 years')) {
        // Replace "28 years" with bold version
        em.innerHTML = text.replace(/(8 years)/gi, '<strong>$1</strong>');
      }
      
      // "3+ hours" -> bold (escape the plus)
      if (/\b3\+\s*hours\b/i.test(text)) {
        em.innerHTML = em.innerHTML.replace(/(3\+\s*hours)/gi, '<strong>$1</strong>');
      }
      
      // If text contains "15-year", make it bold
      if (text.toLowerCase().includes('15-year')) {
        // Replace "15-year" with bold version
        em.innerHTML = text.replace(/(15-year)/gi, '<strong>$1</strong>');
      }
      
      // If text contains "23 YEARS", make it bold
      if (text.toLowerCase().includes('23 YEARS')) {
        // Replace "23 YEARS" with bold version
        em.innerHTML = text.replace(/(23 YEARS)/gi, '<strong>$1</strong>');
      }

    });
  });

  // REVIEW SLIDER -- START
  const swiper = new Swiper('.review_slider_swiper', {
    loop: false,
    navigation: {
      nextEl: '.review_slider_next_btn',
      prevEl: '.review_slider_prev_btn',
    },
    slidesPerView: 3,
    spaceBetween: 20,
    breakpoints: {
      1180: {
        slidesPerView: 3.6,
        spaceBetween: 24,
      },
      900: {
        slidesPerView: 2.6,
        spaceBetween: 20,
      },
      767: {
        slidesPerView: 2.1,
        spaceBetween: 20,
      },
      320: {
        slidesPerView: 1.05,
        spaceBetween: 16,
      },
    },
  });
  // STEPS GRID -- START
  const stepSwiper = new Swiper('.steps-grid', {
    slidesPerView: 3.6,
    spaceBetween: 24,
    navigation: {
      nextEl: '.stepsslider_next_btn',
      prevEl: '.stepsslider_prev_btn',
    },
    breakpoints: {
      320: {
        slidesPerView: 1.2,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 2.5,
        spaceBetween: 16,
      },
      1120: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
      1340: {
        slidesPerView: 3.6,
        spaceBetween: 24,
      },
    },
  });

  // CHOOSE-KIT -- START
  const kitsgrid = new Swiper('.kits-grid', {
    slidesPerView:1.2,
    spaceBetween: 24,
    centeredSlides: true,
    navigation: {
      nextEl: '.kits_next_btn',
      prevEl: '.kits_prev_btn',
    },
    breakpoints: {
      320: {
        slidesPerView: 1.2,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 0,
        centeredSlides: false,
      }
    },
  });


  // end of domconent
});

// FAQ
$(document).ready(function() {
  $(".faq_accordion_item > .faq_accordion_item_header").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".faq_accordion_item_body")
        .slideUp(200);
      $(".faq_accordion_item > .faq_accordion_item_header i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".faq_accordion_item > .faq_accordion_item_header i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".faq_accordion_item > .faq_accordion_item_header").removeClass("active");
      $(this).addClass("active");
      $(".faq_accordion_item_body").slideUp(200);
      $(this)
        .siblings(".faq_accordion_item_body")
        .slideDown(200);
    }
  });
});

// RANDOM NUMBER -- START
document.addEventListener("DOMContentLoaded", function() {
  var randomNum = Math.floor(Math.random() * (49 - 18 + 1)) + 18;
  var element = document.querySelector(".random_number_count strong");
  if (element) {
    element.textContent = randomNum;
  }
});
// RANDOM NUMBER -- END

// CURRENT_DATE -- START
document.addEventListener("DOMContentLoaded", function() {
  const elements = document.querySelectorAll("body, body *");

  elements.forEach(el => {
    if (el.children.length === 0 && el.textContent.includes("[current_date]")) {
      const future = new Date();
      //future.setDate(future.getDate() + 7);
      const options = { day: 'numeric', month: 'long', year: 'numeric' };
      const formatted = future.toLocaleDateString('en-US', options);
      el.textContent = el.textContent.replace("[current_date]", formatted);
    }
  });
});
// CURRENT_DATE -- END

// Advertorial Sticky Button js start
document.addEventListener('DOMContentLoaded', () => {
    const targetSection = document.querySelector('.shopify-section-group-footer-group-new');
    const element = document.querySelector('.landing-sticky-btn');
    const className = 'sticky_btn_active';

    // Stop script if button OR section is missing
    if (!targetSection || !element) return;

    window.addEventListener('scroll', () => {
        const sectionTop = targetSection.offsetTop - 350;
        const scrollPosition = window.scrollY + window.innerHeight / 2;

        if (scrollPosition >= sectionTop) {
            element.classList.remove(className);
        } else {
            element.classList.add(className);
        }
    });
});



// Advertorial Sticky Button js End
